module.exports = __webpack_public_path__ + "static/media/02d.840baef0.png";